export const getters = {
  getAtividadeOs: (state) => state.atividadeOs,
  getAtividadesOs: (state) => state.atividadesOs,
  getModalCadastroAtividadeOs: (state) => state.modalCadastroAtividadeOs,
  getModalExcluirAtividadeOs: (state) => state.modalExcluirAtividadeOs,
  
};

export default {};
